// components
import { Button } from '@mui/material';

// styles
import { ActionBar } from './FormActionBar.styles';

// libraries
import { useTranslation } from 'react-i18next';

// types
import { FormActionBarProps } from './FormActionBar.types';

// hooks
import { useFormContext } from 'react-hook-form';

const FormActionBar = ({ disabled, onSave, onCancel }: FormActionBarProps) => {
  'use memo';
  const { t } = useTranslation('common');
  const { formState } = useFormContext();

  return (
    <ActionBar>
      <Button size="large" onClick={onCancel} variant="outlined">
        {t('cancel')}
      </Button>
      <Button
        type="submit"
        size="large"
        disabled={!formState.isDirty || disabled}
        onClick={onSave}
      >
        {t('save')}
      </Button>
    </ActionBar>
  );
};

export default FormActionBar;
